export function hexToVec3(hex: string | undefined | null): [number, number, number] {
    if (!hex) {
        return [0, 0, 0];
    }
    try {
        const bigint = Number.parseInt(hex.startsWith("#") ? hex.slice(1) : hex, 16);
        const r = (bigint >> 16) & 255;
        const g = (bigint >> 8) & 255;
        const b = bigint & 255;
        return [r / 255, g / 255, b / 255];
    } catch (e) {
        console.error("Invalid hex color:", hex, e);
        return [0, 0, 0];
    }
}
